import { eventsSlice } from './eventsSlice';
import * as actions from "./eventsActions";
import * as selectors from "./eventsSelectors";

export { actions };
export { selectors };

export default eventsSlice.reducer;
